<div>
  <dap-lib-icon
    *ngIf="getIconName$() | async as iconName"
    iconColor="black"
    iconSize="24"
    [name]="iconName"
  ></dap-lib-icon>
  <p [class.open]="!basketIsOpen" class="body-4 bold">
    {{ getFirstNameOrFallback$() | async }}
  </p>
</div>
